import { Injectable } from '@angular/core';

import { Logger } from '@frontend/vanilla/core';
import Dexie from 'dexie';

import { DBTableSchemas, IDB_NAME } from './indexed-db.model';

@Injectable({
    providedIn: 'root',
})
export class IndexedDBService extends Dexie {
    versionNumber: number = 1;

    constructor(private logger: Logger) {
        super(IDB_NAME);
        this.setupIndexedDB();
    }

    private async setupIndexedDB(): Promise<void> {
        this.setIndexedDbTable();
        if (this.isOpen()) return;
        try {
            await this.open();
            this.logger.info('IndexedDB Connected');
        } catch (err) {
            this.logger.error(`Failed to connect ${IDB_NAME} indexedDB, Error: ${err.message}`);
        }
    }

    private setIndexedDbTable(): void {
        this.version(this.versionNumber).stores(this.setTablesSchema());
    }

    private setTablesSchema(): Record<string, string> {
        return DBTableSchemas.reduce((tables: Record<string, string>, { name, schema }) => {
            tables[name] = schema;
            return tables;
        }, {});
    }
}
